import React from 'react'

const About = () => {
    return (
        <div className='genres'>
            <div className='text-dark-back p-1'>
                <h1>Discover new Animes!</h1>
                <h2>Search titles or browes genres</h2>
            </div>

        </div>
    )
}

export default About
